import moment from "moment-timezone";

export type ColunaFiltroLogSinter = "data" | "imovel" | "inscricao" | "cib" | "tipo" | "status";

export type FiltroLogSinter = { coluna: ColunaFiltroLogSinter; valor: string };

export function formatarDataLogSinter(value?: string | null): string {
  if (!value) return "—";
  // Sem offset, o log representa horário local de Brasília, não o fuso do navegador.
  const data = moment.tz(value, moment.ISO_8601, true, "America/Sao_Paulo");
  return data.isValid() ? data.format("DD/MM/YYYY HH:mm:ss") : "—";
}

export const colunasLogSinter: Array<{
  value: ColunaFiltroLogSinter;
  label: string;
  placeholder: string;
  ajuda: string;
}> = [
  {
    value: "data",
    label: "Data/Hora",
    placeholder: "Ex.: 29/07/2026 ou 29/07/2026 09:55",
    ajuda: "Use DD/MM/AAAA. A hora é opcional (HH:mm ou HH:mm:ss), no horário de Brasília. Sem hora, busca o dia inteiro.",
  },
  {
    value: "imovel",
    label: "Nº Cadastro",
    placeholder: "Ex.: 10000099620",
    ajuda: "Informe o número completo ou parte dele, apenas com dígitos.",
  },
  {
    value: "inscricao",
    label: "Inscrição Cartográfica",
    placeholder: "Ex.: 01.15.011.0216.001",
    ajuda: "Informe a inscrição completa ou parte dela, com ou sem pontuação.",
  },
  {
    value: "cib",
    label: "CIB",
    placeholder: "Digite o CIB ou parte dele",
    ajuda: "A busca não diferencia maiúsculas de minúsculas.",
  },
  {
    value: "tipo",
    label: "Tipo",
    placeholder: "Ex.: últimas alterações",
    ajuda: "Informe o tipo ou parte dele. A busca ignora acentos e maiúsculas/minúsculas.",
  },
  {
    value: "status",
    label: "Status",
    placeholder: "Selecione o status",
    ajuda: "Selecione Sucesso ou Erro.",
  },
];

export function validarFiltroLogSinter(coluna: ColunaFiltroLogSinter | "", valor: string): string | null {
  if (!coluna) return "Selecione uma coluna para filtrar.";
  const termo = valor.trim();
  if (!termo) return "Informe um valor para filtrar.";
  if (termo.length > 256) return "O filtro deve ter no máximo 256 caracteres.";

  if (coluna === "data") {
    const formatos = ["DD/MM/YYYY", "DD/MM/YYYY HH:mm", "DD/MM/YYYY HH:mm:ss"];
    const formatoValido = /^\d{2}\/\d{2}\/\d{4}( \d{2}:\d{2}(:\d{2})?)?$/.test(termo);
    const data = moment(termo, formatos, true);
    if (!formatoValido || !data.isValid() || data.year() < 1 || / 24:/.test(termo)) {
      return "Informe uma data válida, como 29/07/2026 ou 29/07/2026 09:55:01.";
    }
  }

  if (coluna === "imovel" && !/^\d+$/.test(termo)) return "Use apenas dígitos no Nº Cadastro.";
  if (coluna === "inscricao" && !/[a-z0-9]/i.test(termo)) return "Informe uma inscrição válida.";
  if (coluna === "status" && termo !== "sucesso" && termo !== "erro") return "Selecione Sucesso ou Erro.";

  return null;
}
